import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { DialogAction } from '../dialogs-configuration';
import { DialogConfigBase } from '../dialog-config-base';
import { DialogComponentInterface } from '../dialog-component.interface';
import { DialogConfigInterface } from '../dialog-config.interface';

@Component({
  selector: 'app-offer-recalculation-dialog',
  templateUrl: './offer-recalculation-dialog.component.html'
})
export class OfferRecalculationDialogComponent implements OnInit, DialogComponentInterface {

  modeSpecificTranslationsContainer: string;
  private readonly translationsContainer = 'OFFER_RECALCULATION_DIALOG_COMPONENT';

  static getConfigBuilder(): any {
    return new OfferRecalculationDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: OfferRecalculationDialogData) {
    this.initModeSpecificTranslationsContainer();
  }

  get isHigherPremiumMode(): boolean {
    return this.data.mode === OfferRecalculationDialogMode.HIGHER_PREMIUM;
  }

  ngOnInit() {
  }

  getTranslationKey(key: string, subContainer?: string): string {
    if (subContainer) {
      return `${this.translationsContainer}.${subContainer}.${key}`;
    }
    return `${this.translationsContainer}.${key}`;
  }

  private initModeSpecificTranslationsContainer(): void {
    switch (this.data.mode) {
      case OfferRecalculationDialogMode.HIGHER_PREMIUM:
        this.modeSpecificTranslationsContainer = 'HIGHER_PREMIUM';
        break;
      case OfferRecalculationDialogMode.LOWER_PREMIUM:
        this.modeSpecificTranslationsContainer = 'LOWER_PREMIUM';
        break;
    }
  }

}

export class OfferRecalculationDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'app-dialog',
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: OfferRecalculationDialogData): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}

export interface OfferRecalculationDialogData {
  mode: OfferRecalculationDialogMode,
  imageSrc: string,
  premiumBeforeRecalculation: number,
  premiumAfterRecalculation: number,
  firstInstallmentAmount: number,
  backToOffersActionKey: DialogAction,
  payActionKey: DialogAction,
}

export enum OfferRecalculationDialogMode {
  HIGHER_PREMIUM = 'HIGHER_PREMIUM',
  LOWER_PREMIUM = 'LOWER_PREMIUM'
}
